export const formatINR = (amount, compact = true) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "—";
  const neg = amount < 0;
  const abs = Math.abs(amount);
  let str;
  if (compact && abs >= 10000000) str = `₹${(abs / 10000000).toFixed(2)} Cr`;
  else if (compact && abs >= 100000) str = `₹${(abs / 100000).toFixed(2)} L`;
  else str = `₹${abs.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
  return neg ? `−${str}` : str;
};

export const formatFullINR = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "—";
  const neg = amount < 0;
  const str = `₹${Math.abs(amount).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
  return neg ? `−${str}` : str;
};

export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const formatDateTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-IN", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};
